/** Normalizes outbound sync attachment payloads: adds a `data:` URL prefix when a field is raw Base64 without `http(s):`, `blob:`, catalog paths, or an existing MIME prefix. */

const SKIP_RAW_PREFIX_RE = /^(https?:|blob:|participantes\/)/i;

const MIN_RAW_B64_CHARS = 32;

/** Typical Base64 alphabet (URL-safe variants intentionally left as opaque strings unless they normalize elsewhere). */
const RAW_BASE64_CHUNK_RE = /^[A-Za-z0-9+/]+=*$/;

/** If `raw` is raw Base64, returns `data:${mimeFallback};base64,<payload>`; otherwise returns the coerced string (empty when `raw` is nullish). */
export function normalizeDataUrlAttachment(raw: string | undefined | null, mimeFallback: string): string {
  const s = raw == null ? '' : raw;
  if (mimeFallback.trim() === '') return s;
  const t = s.trim();
  if (t === '') return s;
  if (t.startsWith('data:')) return s;
  if (SKIP_RAW_PREFIX_RE.test(t)) return s;
  const compact = t.replace(/\s+/g, '');
  if (compact.length < MIN_RAW_B64_CHARS) return s;
  if (!RAW_BASE64_CHUNK_RE.test(compact)) return s;
  return `data:${mimeFallback};base64,${compact}`;
}
